import axios from 'axios';
import qs from 'qs';
// let imageURL = 'http://192.168.2.247:8091/opt/upFiles/';//图片地址
// let baseURL = 'http://192.168.2.247:8091/'

let imageURL = 'http://www.hengzhizikong.com/hengzhi-boot/opt/upFiles/';//生产环境 图片地址
let baseURL = 'http://www.hengzhizikong.com/hengzhi-boot/'//生产环境

axios.defaults.baseURL = baseURL;
// 配置超时时间 五分钟
axios.defaults.timeout = 300000;
// axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

var get = function(url, params, loading) {
    return new Promise((resolve, reject) => {
        // {
        //   params: params
        // }
        axios
            .get(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
};

 var post = function(url, data) {
    return new Promise((resolve, reject) => {
        data = qs.stringify(data);
        axios
            .post(url, data)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
};

// export function updatePassword(parameter) {
//     return axios({
//       url: '/updatePassword',
//       method: 'put',
//       data: parameter
//     })
//   }
// export function login(parameter) {
//     return axios({
//       url: '/login',
//       method: 'post',
//       data: parameter
//     })
//   }
//   export function loginzc(parameter) {
//     return axios({
//       url: '/loginzc',
//       method: 'post',
//       data: parameter
//     })
//   }
//   export function register(parameter) {
//     return axios({
//       url: '/register',
//       method: 'post',
//       data: parameter
//     })
//   }
//   export function addlog(parameter) {
//     return axios({
//       url: '/fwjl',
//       method: 'post',
//       data: parameter
//     })
//   }
  // ,baseReadURL,login,updatePassword,register,addlog,loginzc
export default { get,post, baseURL,imageURL};



// WEBPACK FOOTER //
// ./src/js/axios.js